import { cn } from '@/lib/utils'

/**
 * Intuigence brand square loader (Figma node 11777:60651 "Spinner").
 * A 2×2 grid of 16px cells: three peach (#ffc2a8) fill the grid while one
 * bright-orange (#ff4f17) cell hops clockwise through the four corners
 * (TL → TR → BR → BL), matching the design's 8-frame variant animation.
 * Fixed 32px to match the design; the keyframes are calibrated to 16px hops.
 */
export default function SquareLoader({ className, label }: { className?: string; label?: string }) {
  return (
    <div
      className={cn('relative size-8 shrink-0', className)}
      role="status"
      aria-label={label ?? 'Loading'}
    >
      {/* Static peach grid — the vacated cell stays filled behind the moving square */}
      <span className="absolute left-0 top-0 size-4 bg-[#ffc2a8]" />
      <span className="absolute left-4 top-0 size-4 bg-[#ffc2a8]" />
      <span className="absolute left-4 top-4 size-4 bg-[#ffc2a8]" />
      <span className="absolute left-0 top-4 size-4 bg-[#ffc2a8]" />
      {/* Moving bright-orange cell */}
      <span className="absolute left-0 top-0 size-4 bg-[#ff4f17] animate-square-hop" />
    </div>
  )
}
